import {
  PricingStrategy,
  PricingTier
} from '@atlassiansox/asc-product-catalog';

import { PricingCalculation } from './pricing-calculation';

export type PricingBreakdown = ReadonlyArray<PricingBreakdownItem>;

export type PricingBreakdownItem = {
  readonly units: number;
  readonly unitPrice: number;
  readonly tier: PricingTier;
};

export function reduceBreakdownToPricingCalculation(
  { total, currencyIsoCode, breakdown, pricingPlan }: PricingCalculation,
  { tier, units, unitPrice }: PricingBreakdownItem
) {
  return {
    currencyIsoCode,
    breakdown,
    pricingPlan,
    total: updateTotal(total, tier.pricingStrategy, units, unitPrice)
  };
}

function updateTotal(
  total: number,
  pricingStrategy: PricingStrategy,
  units: number,
  unitPrice: number
) {
  switch (pricingStrategy) {
    case PricingStrategy.FIXED_COST:
      return unitPrice;
    case PricingStrategy.MARGINAL_PER_UNIT:
      return total + units * unitPrice;
    case PricingStrategy.PER_UNIT:
      return units * unitPrice;
  }
}
